export default __webpack_public_path__ + "static/llroux-6f6ab4e84514908e5d5519180003a317.jpeg";